<template>
    <validation-provider v-slot="v" :name="name" :rules="rules" slim mode="eager">
        <div class="form-group mb-0"
             :class="{
                 'has-feedback has-error': v.errors.length,
                 'row': inline && isLabelSlot,
                 'd-flex': inline && isLabelSlot,
             }">
            <div class="d-flex justify-content-between">
                <label v-if="isLabelSlot" :for="id" :class="labelClass" class="mb-0 mt-2">
                    <slot name="label" />
                </label>
                <div class="btn-group">
                    <button type="button"
                            v-for="(item, i) of langs"
                            :key="i"
                            @click="setLang(item)"
                            class="btn btn-xs text-uppercase"
                            :class="{ 'btn-primary': item === lang }">
                        {{ item }}
                    </button>
                </div>
            </div>
            <div :class="{'col-md-7':labelClass.length}">
                <textarea :id="id"
                          :name="name"
                          :rows="rows"
                          v-model="data[lang]"
                          @input="update"
                          :class="{'is-invalid': v.errors.length, 'custom-green-input-bg': !noCustomBg}"
                          class="form-control"/>
                <div class="invalid-feedback">
                    {{ v.errors[0] }}
                </div>
            </div>
        </div>
    </validation-provider>
</template>

<script>
export default {
    name: 'AppMultiLangTextarea',
    props: {
        id: [String, Number],
        value: Object,
        noCustomBg: Boolean,
        rows: {
            type:Number,
            default: 3
        },
        inline: Boolean,
        langs: Array,
        name: String,
        rules: String
    },
    data() {
        return {
            lang: this.$i18n.locale || 'en'
        };
    },
    computed: {
        data: {
            get() {
                if (this.value && typeof this.value === 'object' && this.value.constructor === Object) {
                    return this.value;
                }

                return {};
            }
        },
        labelClass() {
            if (this.inline) {
                return 'col-md-3 col-form-label text-md-right';
            }

            return '';
        },
        isLabelSlot() {
            return !!this.$slots.label;
        }
    },
    methods: {
        update() {
            this.$emit('input', this.data);
        },
        setLang(lang) {
            this.lang = lang;
        }
    }
};
</script>
